import React, { useRef, useState } from 'react';
import { createStateMachine, MachineConfig } from './createStateMachine';
import Step1 from './comps/Step1';
import Step2 from './comps/Step2';
import Step3 from './comps/Step3';
import Step4 from './comps/Step4';
import Step5 from './comps/Step5';
import Form from './comps/Form';
import NotQualified from './comps/NotQualified';
import css from './index.module.scss';
import Disclaimer from './comps/Disclaimer';
import FormSuccess from './comps/FormSuccess';

type State = 'step1' | 'step2' | 'step3' | 'step4' | 'step5' | 'disclaimer' | 'form' | 'formSuccess' | 'notQualified';
export type RemoteInstallFormContext = {
    step1: 'yes' | 'no';
    step2: 'yes' | 'no';
    step3: 'yes' | 'no';
    step4: 'unsure' | 'electricians' | 'my';
    step5: 'has' | 'only' | 'not';
};

// 流程
const surveyConfig: MachineConfig<RemoteInstallFormContext, State, any> = {
    initial: 'step1',
    states: {
        step1: {
            component: Step1, // step1 组件内容
            on: {
                yes: 'notQualified', // 选项 yes 跳 notQualified
                no: 'step2', // 选项 no 跳 step2
            },
        },
        step2: {
            component: Step2,
            on: {
                yes: 'notQualified',
                no: 'step3',
            },
        },
        step3: {
            component: Step3,
            on: {
                yes: 'step4',
                no: 'notQualified',
            },
        },
        step4: {
            component: Step4,
            on: {
                unsure: 'notQualified',
                electricians: 'disclaimer',
                my: 'step5',
            },
        },
        step5: {
            component: Step5,
            on: {
                has: 'disclaimer',
                only: 'notQualified',
                not: 'notQualified',
            },
        },
        disclaimer: {
            component: Disclaimer,
            on: {
                next: 'form',
            },
        },
        form: {
            component: Form,
            on: {
                done: 'formSuccess',
            },
        },
        formSuccess: {
            component: FormSuccess,
        },
        notQualified: {
            component: NotQualified,
        },
    },
};

const RemoteInstallForm: React.FC = ({}) => {
    // 创建状态机实例
    const machineRef = useRef(createStateMachine(surveyConfig, {}));
    const machine = machineRef.current;

    // React 用于重新渲染
    const [state, setState] = useState(machine.state);

    const send = (event: any) => {
        machine.send(event, event === 'BACK' ? undefined : { [machine.state]: event });
        setState(machine.state); // 更新渲染
        window.scrollTo({ behavior: 'instant', top: 0 });
    };

    // 获取当前状态对应组件
    const Component = surveyConfig.states[state].component as React.ComponentType<any>;

    return (
        <div className={css.container}>
            <Component send={send} context={machine.context} />
        </div>
    );
};
export default RemoteInstallForm;
